/* file description */

import type { UseRecordCreatorProp } from './type';

export const useRecordCreatorProp: UseRecordCreatorProp = ({ recordCreatorProps }) => {
  return (
    recordCreatorProps ?? false
  );
};
